import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import BackgroundPic from '../../assets/background_forms_light.svg';

const useStyles = makeStyles((theme: Theme) => ({
  contentContainer: {
    paddingTop: '4%',
    backgroundColor: theme.palette.background.defaultSecondary,
    minHeight: '100%',
    backgroundImage: `url(${BackgroundPic})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      paddingTop: '2%',
    },
  },
  avatar: {
    width: 100,
    [theme.breakpoints.down('md')]: {
      width: 70,
    },
  },
}));

export default useStyles;
